import { FC } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import { FlashOn as FlashOnIcon } from "@material-ui/icons";

import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    valuationIconBase: {
      borderRadius: "50%",
      height: "16px",
      width: "16px",
    },
    canGetValuation: {
      backgroundColor: theme.custom.palette.green.main,
      color: theme.palette.background.default,
    },
    canNotGetValuation: {
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${theme.custom.palette.green.main}`,
      color: theme.custom.palette.green.main,
    },
  }),
);

const CanGetValuationIcon: FC<{
  canGetValuation: boolean;
  showLabel: boolean;
}> = ({ canGetValuation, showLabel }) => {
  const classes = useStyles();
  return (
    <>
      <FlashOnIcon
        className={`${classes.valuationIconBase} ${
          canGetValuation ? classes.canGetValuation : classes.canNotGetValuation
        }`}
      />
      {showLabel && (
        <>
          {canGetValuation ? (
            <>&nbsp;Instant Connection</>
          ) : (
            <>&nbsp;Custom Valuation</>
          )}
        </>
      )}
    </>
  );
};

export default CanGetValuationIcon;
